import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import FormQualification from 'system/components/qualifications/form';
import { CommonQualificationCrumbs } from '../constants';

const QualificationNewPage = (): React.ReactElement => {
  const { post: insertQualification } = useHttpFetch(`${__MANAGEMENT_API_URL__}/qualifiche`);
  const navigate = useNavigate();
  const onSubmit = useCallback(
    (formValues) => {
      insertQualification({
        descrizione: formValues.name,
        note: formValues.lastUpdate,
        key: {
          codiceQualifica: formValues.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/qualifiche');
      });
    },
    [insertQualification, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonQualificationCrumbs, { name: 'Nuova Qualifica' }]} />
      <FormQualification
        title="Nuova Qualifica"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/qualifiche');
        }}
      />
    </Fragment>
  );
};

QualificationNewPage.displayName = 'Qualification new page component';

export default QualificationNewPage;
